import { use, useEffect, useState } from "react";
import LangController from "../controllers/LangController";
import Lang from "../models/Lang";
import { useModal } from "../_providers/ModalProvider";
import { AddKeyValueModal } from "../_modals/AddKeyValueModal";
import SingleInputModal from "../_modals/SingleInputModal";

const LangPage = () => {
    const {setModal, closeModal} = useModal();

    const [langs, setLangs] = useState<Lang[]>([]);
    const [selected, setSelected] = useState<number>(0);

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");

    const reloadLangs = () => {
        LangController.getLangs()
        .then((langs) => {
            setLangs(langs);
            setLoading(false);
        })
        .catch((error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    const addLangData = (lang: string, key: string, value: string) => {
        LangController.addLangData(lang, key, value)
        .then(() => {
            reloadLangs();
        })
        .catch((error) => {
            setError(error.message);
        });
    }
    
    const deleteLangData = (lang: string, key: string) => {
        LangController.deleteLangData(lang, key)
        .then(() => {
            reloadLangs();
        })
        .catch((error) => {
            setError(error.message);
        });
    }

    useEffect(() => {
        reloadLangs();
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    return (
      <div>
        <h1>Language Page</h1>
        <select onChange={(e) => setSelected(parseInt(e.target.value))}>
            {langs.map((lang, index) => (
                <option key={lang.uid} value={index}>
                    {lang.uid}
                </option>
            ))}
        </select>
        <button onClick={() => setModal("Create Language", <SingleInputModal onCreate={(value) => {LangController.createLang(value); reloadLangs(); closeModal()}}/>)}>New Language</button>
        <h2>{langs[selected].uid}</h2>
        <button onClick={e => setModal("Add translation", <AddKeyValueModal onCreate={(key, value) => addLangData(langs[selected].uid, key, value)}/>)}>Add</button>
        <h3>Data</h3>
        <ul>
            {Object.entries(langs[selected].data).map(([key, value]) => (
                <li key={key}>
                    {key}: {value}
                    <button onClick={() => deleteLangData(langs[selected].uid, key)}>Delete</button>
                </li>
            ))}
        </ul>
      </div>
    );
  }
  export default LangPage;